import gql from 'graphql-tag';

const priceFragment = gql`
    fragment priceInfo on Price {
        price
        asOfDate
    }
`;

export const HISTORICAL_PRICES_TABLE = gql`
    query HistoricalPrices($ticker: String!) {
        mutualFund(ticker: $ticker) {
            price {
                asOfDate
            }
            monthlyHighPrice {
                ...priceInfo
            }
            monthlyLowPrice {
                ...priceInfo
            }
            monthEndHighPrice {
                ...priceInfo
            }
            ytdLowPrice {
                ...priceInfo
            }
            ytdHighPrice {
                ...priceInfo
            }
            annualHistoricalLowPrices {
                ...priceInfo
            }
            annualHistoricalHighPrices {
                ...priceInfo
            }
        }
    }
    ${priceFragment}
`;
